import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { WeekTimeRecord } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  deleteTimeRecord(request: Boundaries["deleteTimeRecord"]["request"]): void;
}

function useDeleteTimeRecord(timeRecord: WeekTimeRecord): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDeleteTimeRecordRequestPending(timeRecord),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDeleteTimeRecordRequestSuccess(timeRecord),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDeleteTimeRecordRequestFailure(timeRecord),
    ),
    deleteTimeRecord: core.deleteTimeRecord,
  };
}

export { useDeleteTimeRecord };
